import { Fragment } from 'react';
/*  @ts-ignore Jun-18-2025, 19:10UTC fix types  */
import LegalConsentFields from 'FormsCommonComponents/LegalConsentFields';
/*  @ts-ignore Jun-18-2025, 19:10UTC fix types  */
import LegalConsent from 'FormsCommonComponents/lib/LegalConsent';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const LegalConsentInputs = ({
  legalConsentOptions,
  legalConsentResponses,
  setGivenConsent
}) => {
  const previewModel = new LegalConsent(legalConsentOptions.convertToJSON());
  return /*#__PURE__*/_jsx(Fragment, {
    children: /*#__PURE__*/_jsx(View, {
      backgroundColor: "fill-surface-recessed",
      borderColor: "border-core-subtle",
      borderRadius: "300",
      borderStyle: "solid",
      borderWidth: "100",
      padding: "400",
      children: /*#__PURE__*/_jsx(LegalConsentFields, {
        legalConsentRecord: previewModel,
        legalConsentResponses: legalConsentResponses,
        onCommunicationCheckboxChange: setGivenConsent
      })
    })
  });
};
export default LegalConsentInputs;